import angular from 'angular';
import {
    CandidateWorkflowSteps,
    CandidateWorkflowStepsConfiguration,
} from '../../../candidate/workflow-steps';

export class RecruiterCandidateWorkflowSteps extends CandidateWorkflowSteps {
    status = 'recruiterStatus';
    pathName = 'recruiter.candidatesJob';

    getCandidateWorkflowCount(workflowData, status, workflowStep) {
        if (workflowStep === 'Prospect') {
            return this.prospectsCandidatesCount;
        }

        return super.getCandidateWorkflowCount(workflowData, status, workflowStep);
    }
}

export const RecruiterCandidateWorkflowStepsConfiguration = {
    ...CandidateWorkflowStepsConfiguration,
    bindings: {
        ...CandidateWorkflowStepsConfiguration.bindings,
        prospectsCandidatesCount: '<',
    },
    controller: RecruiterCandidateWorkflowSteps,
};

angular
    .module('TALENYA-FE')
    .component('recruiterCandidateWorkflowSteps', RecruiterCandidateWorkflowStepsConfiguration);
